import React from 'react';
import styles from './index.module.scss';
import cx from 'clsx';

const Label = ({ children, required, className, size, ...rest }) => {
  const setClass = (size) => {
    switch (size) {
      case size:
        return styles[size];
      default:
        return '';
    }
  };

  return (
    <label className={cx(styles.label, className, setClass(size))} {...rest}>
      {children} {!required && <small style={{ color: 'var(--gray-500)', fontWeight: 400 }}>(optional)</small>}
    </label>
  );
};

export default Label;
